import { MDatePicker, ResponsiveFormContainer } from "@app/components";
import { MODES_OPTIONS } from "@app/types/generics.types";
import { Grid, Typography } from "@mui/material";
import dayjs from "dayjs";
import React from "react";
import { useFormContext } from "react-hook-form";

interface DateRangeFormProps {
  mode: MODES_OPTIONS;
  title?: string;
}

const DateRangeForm = ({
  mode,
  title = "Por rango de fechas finales de toma de muestra",
}: DateRangeFormProps) => {
  const form = useFormContext();
  const isView = mode === MODES_OPTIONS.VIEW;
  return (
    <>
      <Grid item xs={12} my={2}>
        <Typography variant="tagText">{title}</Typography>
      </Grid>
      <ResponsiveFormContainer columns={5}>
        <MDatePicker
          name="evo_start_date"
          pickerType="date"
          label="Fecha inicio de recogida"
          validation={{
            required: "La fecha es requerida",
          }}
          maxDate={dayjs(form.watch("evo_end_date")) || null}
          disabled={isView}
        />
        <MDatePicker
          name="evo_end_date"
          pickerType="date"
          label="Fecha final recogida"
          validation={{
            required: "La fecha es requerida",
          }}
          minDate={dayjs(form.watch("evo_start_date")) || null}
          disabled={isView}
        />
      </ResponsiveFormContainer>
    </>
  );
};
export default DateRangeForm;
